import React from 'react'

function Choose() {
  return (
  <>
  <section>
    <div className='container'>
        <div>
            <h3>Why Choose Us?</h3>
            <p>Triplette is your trusted career partner, offering personalized job placement, expert guidance, and ethical support to help you grow in the IT & ITES industry. We connect you with top employers and empower your career journey every step of the way.</p>
        </div>
    </div>
  </section>
  </>
  )
}

export default Choose
